<template>
	<div>
		<v-divider />
		<div
			class="tour-step-footer"
			:style="{ padding: `var(--sgnl-space-12) ${horizontalPadding}` }"
		>
			<span class="sgnl-paragraph-s-regular tour-step-counter sgnl-text-color-secondary">
				{{ stepNumber }}/{{ totalSteps }}
			</span>
			<div class="tour-step-actions">
				<slot />
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "TourStepFooter",
	props: {
		stepNumber: { type: Number, required: true },
		totalSteps: { type: Number, required: true },
		horizontalPadding: { type: String, default: "var(--sgnl-space-16)" },
	},
});
</script>

<style lang="scss" scoped>
.tour-step-footer {
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: var(--sgnl-default-secondary-background-mono);
	border-radius: 0 0 var(--sgnl-border-radius-8) var(--sgnl-border-radius-8);
}

.tour-step-actions {
	display: flex;
	align-items: center;
	gap: var(--sgnl-space-8);
}
</style>
